import type { PlanStatus } from "./types/brand.types";

/** The one palette a plan's status is drawn in, whichever way the list is
 *  laid out — the table from `md` up and the cards below it both read from
 *  this, so the same status never arrives in two different colours. */
export const PLAN_STATUS_STYLES: Record<PlanStatus, string> = {
  Active: "bg-brand-soft text-[#00899B]",
  "In-active": "bg-[#F1F4F6] text-ink-muted",
};

/** The pill itself, minus its colours. No border on these: they sit inside a
 *  row or a card, not beside a page heading. */
export const PLAN_STATUS_PILL =
  "inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-[12px] font-medium";
